import axios from "axios";
import { API_KEY, API_URL } from "../config";


export const sendContactRequest = async (data) => {
    return axios.post(`${API_URL}/api/contact`, data, {
        headers: {
            "X-API-Key": API_KEY,
        },
    });
};
